import Loader from '~lib/ui-kit/Loader'
import NoSsr from '~lib/ui-kit/NoSsr'
import Flex from '~shared/ui/Flex'

interface LoadingLayoutProps {
  children?: React.ReactNode
  loading?: boolean
  className?: string
}

function LoadingLayout({ children, loading, className }: LoadingLayoutProps) {
  if (loading) {
    return (
      <NoSsr>
        <Flex align="center" justify="center" className={className}>
          <Loader size="l" />
        </Flex>
      </NoSsr>
    )
  }

  if (children) {
    return <NoSsr>{children}</NoSsr>
  }

  return null
}

export default LoadingLayout
